import styled from 'styled-components'

import { style } from 'theme'

export const Container = styled.div<{ backgroundColor?: string }>`
  display: flex;
  justify-content: space-between;
  padding: 23px 18px 0 18px;
  align-items: center;
  background: ${props => props.backgroundColor ?? props.theme.colors.white};
`

export const TitleMobile = styled.h3`
  font-weight: 600;
  font-size: 14px;
  color: ${style(theme => theme.colors.slate)};
  margin: 0;
`

export const SubTitleMobile = styled.h5`
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: ${style(theme => theme.colors.stone)};
  margin: 0;
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
`

export const CancelButton = styled.button`
  border: none;
  background: none;
  font-size: 12px;
  font-weight: 600;
  line-height: 22px;
  color: ${style(theme => theme.colors.stone)};
`
